module.exports = __webpack_public_path__ + "static/img/tenpay.6d220245.png";